export const VERY_GOOD_SECURITY = {
  development: "tntazhyknp1",
  production: "tnt8w6nrmbu",
};
